// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"AppPage_overlayWrapper__+-eVD","details":"AppPage_details__f8ZgS","content":"AppPage_content__sHT6w"};